/* eslint-disable camelcase */
import './CSBE.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class CSBE extends PageManager {

	constructor (pageContext) {
		super(pageContext);
	}

	onReady () {
		this.jsonUrl = this.setJsonUrl();

		this.initQuantify();
		this.initSubscriptionUpdate();
	}

	async initQuantify () {
		const quantifyElements = document.getElementsByClassName('js-quantify');

		if (!quantifyElements) {
			return;
		}

		const {Quantify} = await import('extensions/quantify');

		for (const quantifyElement of quantifyElements) {
			new Quantify({
				wrapper: quantifyElement
			});
		}
	}

	setJsonUrl () {
		let jsonUrl = window.json_url ?? '';

		if (jsonUrl && jsonUrl.endsWith('?')) {
			jsonUrl = jsonUrl.split('?', 1)[0];
		}

		return jsonUrl;
	}

	initSubscriptionUpdate () {
		const formElement = document.getElementById('csbe_form');

		if (!formElement) {
			return;
		}

		const shippingMethodListElement = document.getElementById('js-shipping-method');

		if (shippingMethodListElement) {
			const subscriptionChangeElements = formElement.getElementsByClassName('js-subscription-change');

			for (const subscriptionChangeElement of subscriptionChangeElements) {
				subscriptionChangeElement.addEventListener('change', () => {
					this.updateSubscriptionShippingMethodList(formElement, shippingMethodListElement);
				});
			}
		}
	}

	// eslint-disable-next-line max-lines-per-function
	async updateSubscriptionShippingMethodList (formElement, shippingMethodListElement) {
		if (!this.jsonUrl || !(shippingMethodListElement instanceof HTMLSelectElement)) {
			return;
		}

		const {default: LoadingUI} = await import('extensions/loading-ui');

		const loadingUI = new LoadingUI(document.getElementById('js-loading-container'), {
			overlayElement: document.getElementById('js-loading-overlay')
		});

		const formData = new FormData(formElement);

		loadingUI.show();

		const response = await fetch(this.jsonUrl, {
			body: JSON.stringify({
				Address_ID: formData.get('Address_ID'),
				Function: 'Module',
				Module_Code: 'cmp-cssui-subscriptionfields',
				Module_Function: 'SubscriptionShippingMethodList_Load',
				PaymentCard_ID: formData.get('PaymentCard_ID'),
				ProductSubscriptionTerm_ID: formData.get('ProductSubscriptionTerm_ID'),
				Quantity: formData.get('Quantity'),
				Session_Type: 'runtime',
				Store_Code: this.pageContext.Store_Code,
				Subscription_ID: formData.get('Subscription_ID')
			}),
			headers: {
				'Content-Type': 'application/json'
			},
			method: 'POST'
		});

		if (!response.ok) {
			loadingUI.hide();

			throw new Error('Network response was not successful');
		}

		const responseBody = await response.json();
		const shippingMethods = responseBody?.data?.data;

		if (!Array.isArray(shippingMethods)) {
			loadingUI.hide();

			throw new Error('Invalid shipping methods list returned');
		}

		const currentShippingMethod = shippingMethodListElement.value;

		for (let index = shippingMethodListElement.options.length; index >= 0; index--) {
			shippingMethodListElement.remove(index);
		}

		shippingMethods.forEach((method) => {
			const optionElement = document.createElement('option');
			const optionValue = `${method.mod_code}:${method.code}`;

			optionElement.innerHTML = `${method.name} (${method.formatted_price})`;
			optionElement.value = optionValue;

			if (currentShippingMethod === optionValue) {
				optionElement.selected = true;
			}

			shippingMethodListElement.add(optionElement);
		});

		if (!shippingMethodListElement.value && shippingMethodListElement.options.length) {
			shippingMethodListElement.value = shippingMethodListElement.options[0].value;
		}

		loadingUI.hide();
	}

}
